import { Amplify } from 'aws-amplify';
import { amplifyConfig } from './amplify';
import awsExports from '../aws-exports';
import { parseAmplifyConfig } from 'aws-amplify/utils';

export function configureAmplifyCore() {
  const config = parseAmplifyConfig(awsExports);
  Amplify.configure({
    ...config,
    ...amplifyConfig
  }, {

  });
    
  return Amplify;
}
